import { render, staticRenderFns } from "./emailTemplatesList.vue?vue&type=template&id=e5464ec4&scoped=true"
import script from "./emailTemplatesList.vue?vue&type=script&lang=js"
export * from "./emailTemplatesList.vue?vue&type=script&lang=js"
import style0 from "./emailTemplatesList.vue?vue&type=style&index=0&id=e5464ec4&prod&lang=scss&scoped=true"
import style1 from "./emailTemplatesList.vue?vue&type=style&index=1&id=e5464ec4&prod&lang=scss"
import style2 from "./emailTemplatesList.vue?vue&type=style&index=2&id=e5464ec4&prod&lang=scss&scoped=true"
import style3 from "./emailTemplatesList.vue?vue&type=style&index=3&id=e5464ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5464ec4",
  null
  
)

export default component.exports